function checkRegistrationUrl({ state, input, output }) {
  state.set('client.currentPage', input.currentPage)
  const {
    requestAccess,
    remoteLogin,
    currentPage,
    addresstypes,
    registration
  } = state.get('client')

  if (!requestAccess && !remoteLogin) {
    output.error({})
    return
  }

  if (currentPage === 'done') {
    state.merge('client.registrationStep', {
      previousPage: null,
      isLast: false,
      isFirst: false,
      nextPage: null,
      addresstypeIndex: null
    })
    output.success({})
    return
  }

  if (currentPage === 'common') {
    state.merge('client.registrationStep', {
      previousPage: 'login',
      isLast: false,
      isFirst: true,
      nextPage: addresstypes[0],
      addresstypeIndex: null
    })
    output.success()
    return
  }

  if (addresstypes.length && registration.length) {
    const addresstypeIndex = addresstypes.reduce((acc, type, index) => {
      if (type === currentPage) {
        acc = index
      }
      return acc
    }, -1)

    if (addresstypeIndex > -1) {
      let previousPage = null
      let nextPage = null
      if (addresstypeIndex === 0) {
        previousPage = 'common'
      } else {
        previousPage = addresstypes[addresstypeIndex - 1]
      }

      if (addresstypeIndex === addresstypes.length - 1) {
        nextPage = 'done'
      } else {
        nextPage = addresstypes[addresstypeIndex + 1]
      }

      state.merge('client.registrationStep', {
        nextPage,
        previousPage,
        isLast: addresstypeIndex === addresstypes.length - 1,
        isFirst: false,
        addresstypeIndex
      })
      output.success()
      return
    }

    output.error({})
  }
}

export default checkRegistrationUrl



// WEBPACK FOOTER //
// ./src/modules/login/actions/checkRegistrationUrl.js